var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n  Sent camera\n  "),_c('span',{staticClass:"sim-hover primary--text",on:{"click":function($event){return _vm.openCameraDialog(_vm.getExid)}}},[_vm._v("\n    "+_vm._s(_vm.getName)+"\n  ")]),_vm._v("\n  share request to "+_vm._s(_vm.getShareeEmail)+".\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }